/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceListingRequest {
    getFixupPrototypeFunction() { return ResourceListingRequest.fixupPrototype; }

    static newInstance(model: Partial<ResourceListingRequest>): ResourceListingRequest {
        let obj = Object.assign(new ResourceListingRequest(), model);
        ResourceListingRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceListingRequest>): ResourceListingRequest {
        if (!model) return null;
        return ResourceListingRequest.newInstance(<ResourceListingRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceListingRequest) {
        if (!obj) return;

        models.ResourceListingRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceListingRequest): boolean {
        Object.setPrototypeOf(obj, ResourceListingRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Type like cloud
     */
    cloud_type: string;

    /**
     * Type of cloud from cloud provider like AWS/Azure
     */
    cloud: models.CloudServiceName;

    /**
     * The region of the cloud account where it needs to be executed mandatory for AWS
     */
    region: string;

    /**
     * Specify the Cloud account ID. This is a unique ID and can be retrieved from the List Cloud Account API.
     */
    cloud_account_id: string;

    /**
     * Resource groups preferred by the user in that particular Azure account.
     */
    resource_group: string;

    /**
     * Provide the location. Based on the action
     */
    location: string;

    /**
     * Provide the action name. Example: virtual_network.list_virtual_network
     */
    action: string;

}
